/** Two fold bands of a трюмо sheet, sheet px (int), left to right: `[[start, end], [start, end]]`. */
export type FoldBands = [[number, number], [number, number]];

export function foldBandCentres(bands: FoldBands): [number, number] {
  return [Math.floor((bands[0][0] + bands[0][1]) / 2), Math.floor((bands[1][0] + bands[1][1]) / 2)];
}

/** Three panels = sheet minus the bands, left to right, full height. */
export function panelRects(
  width: number,
  height: number,
  bands: FoldBands,
): Array<{ x: number; y: number; width: number; height: number }> {
  const edges: Array<[number, number]> = [
    [0, bands[0][0]],
    [bands[0][1], bands[1][0]],
    [bands[1][1], width],
  ];
  return edges.map(([start, end]) => ({ x: start, y: 0, width: end - start, height }));
}
